"use client";

/**
 * CollabV3SeeInApp 컴포넌트
 * @description 맛보기 아래의 `See the rest in the app`(2.0 웹 상세의 월 안내 문구) — 스레드 전체 · 작품
 *   목록은 앱에서 본다. 앱이 없으면 스토어로 간다(`openInApp`). 웹은 쪽을 넘기지 않는다.
 * @example <CollabV3SeeInApp subject={subject} placement="thread" path={paths.thread} />
 */
import { Button } from "@fanwork-web/design-system";
import { memo } from "react";

import type { CollabV3SeeInAppProps } from "./CollabV3Detail.types";
import { useCollabV3OpenApp } from "./useCollabV3OpenApp";

import { COLLAB_V3_COPY } from "../../constants/collabV3Copy";

const CollabV3SeeInApp = memo<CollabV3SeeInAppProps>(
  ({ subject, placement, path }) => {
    const open = useCollabV3OpenApp(subject, placement, path);
    return (
      <Button
        text={COLLAB_V3_COPY.app.seeRest}
        tone="outlined"
        size="md"
        radius="circle"
        fullWidth
        onClick={open}
      />
    );
  },
);

CollabV3SeeInApp.displayName = "CollabV3SeeInApp";

export default CollabV3SeeInApp;
